import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: 'progress-bar.html'
})
export class ProgressBarComponent implements OnChanges, OnInit {

  @Input('percentage') public percentage: number;
  @Input('configColor') public configColor: any;
  @Input('numVotes') public numVotes: number;
  @Input('statsView') public statsView: boolean;

  public currentPercent: number = 0;
  public interval: any = null;

  constructor() { }

  ngOnInit() {
    this.currentPercent = this.percentage;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.percentage && !changes.percentage.isFirstChange()) {
      let diff: any = (this.currentPercent || 0)  - (changes.percentage.currentValue || 0);
      diff = parseInt(diff);

      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      if (diff < 0) {
        diff = diff * -1;
        this.interval = setInterval(() => {
          this.currentPercent += 1;
          diff -= 1;
          if (diff < 1) {
            clearInterval(this.interval);
            this.interval = null;
            this.currentPercent = changes.percentage.currentValue;
          }
        }, 30);
      } else if (diff > 0) {
        this.interval = setInterval(() => {
          this.currentPercent -= 1;
          diff -= 1;
          if (diff < 1) {
            clearInterval(this.interval);
            this.interval = null;
            this.currentPercent = changes.percentage.currentValue;
          }
        }, 30);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts